import type { Editor, Range } from 'slate';
import isValidPoint from '@atlas/tool/box/slate/isValidPoint';

export default function isValidRange(editor: Editor, range: Range): boolean {
    return isValidPoint(editor, range.anchor) && isValidPoint(editor, range.focus);
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('isValidRange', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
